import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX } from 'react-icons/fi';
import Login from '../../pages/Auth/Login';
import Register from '../../pages/Auth/Signup';

const AuthModal = ({ isOpen, onClose, initialMode = 'login' }) => {
    const [mode, setMode] = useState(initialMode); // 'login' or 'signup'

    if (!isOpen) return null;

    return (
        <AnimatePresence>
            <div className="fixed inset-0 z-[1000] flex items-center justify-center p-5 bg-black/80 backdrop-blur-md">
                <motion.div
                    initial={{ opacity: 0, scale: 0.9, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.9, y: 20 }}
                    className="relative w-full max-w-[480px] bg-background rounded-[32px] border border-border p-5 md:p-10 shadow-2xl max-h-[90vh] overflow-y-auto no-scrollbar"
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        onClick={onClose}
                        className="absolute top-6 right-6 w-9 h-9 rounded-full bg-card border border-border text-muted-foreground hover:text-foreground flex items-center justify-center z-10 transition-colors"
                    >
                        <FiX size={20} />
                    </button>

                    {mode === 'login' ? (
                        <Login
                            isModal={true}
                            onToggleMode={() => setMode('signup')}
                        />
                    ) : (
                        <Register
                            isModal={true}
                            onToggleMode={() => setMode('login')}
                        />
                    )}
                </motion.div>
            </div>
        </AnimatePresence>
    );
};

export default AuthModal;
